export default __webpack_public_path__ + "static/media/favonius_codex.6e201cfa.png";